import React, {useEffect, useState} from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {VisitRequestDto} from "../../../../../../modules/vms/dto/VisitRequestDto";
import Descriptions from "../../../../../../components/Descriptions";
import DescriptionItem from "../../../../../../components/DescriptionItem";
import {Button, Card, CardActions, CardContent, CardHeader, TableCell, TableRow} from "@mui/material";
import StringUtils from "../../../../../../utils/StringUtils";
import {RequestVisitorDto} from "../../../../../../modules/vms/dto/RequestVisitorDto";
import {VisitorStatus} from "../../../../../../modules/vms/enums/VisitorStatus";
import AddIconButton from "../../../../../../components/buttons/AddIconButton";
import ModifyIconButton from "../../../../../../components/buttons/ModifyIconButton";
import Host2ndDialog from "./Host2ndDialog";

export type VisitorDetailCardProps = {
    visitRequest?: VisitRequestDto;
    requestVisitor: RequestVisitorDto;
    onRefresh: () => void;
};

const VisitorDetailCard: React.FC<VisitorDetailCardProps> = (props) => {
    const intl = useIntl();

    const [openHost2Dialog, setOpenHost2Dialog] = useState(false);

    const _handleClickModify = () => {
        setOpenHost2Dialog(true);
    }

    let host2nd = "";
    let host2Json;
    if (props.visitRequest && props.visitRequest.remarks) {
        host2Json = JSON.parse(props.visitRequest.remarks);
        if (host2Json) {
            host2nd = host2Json.hostName2 + "," + host2Json.hostDepartmentName2
        }
    }


    const carryGoods = props.requestVisitor.carryGoods;
    let carryGoodsJson;
    if (carryGoods) {
        carryGoodsJson = JSON.parse(carryGoods);
    }

    return (
        <Card>
            <Host2ndDialog open={openHost2Dialog}
                           visitRequest={props.visitRequest}
                           onClose={() => setOpenHost2Dialog(false)}
                           onOk={() => props.onRefresh()}/>
            <CardHeader title={props.visitRequest?.number}/>
            <CardContent>
                <Descriptions column={1}>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_ARRIVE_DATE'})}>
                        {StringUtils.formatDate(props.visitRequest?.arriveStartDate)}
                    </DescriptionItem>
                    {/*<DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_ARRIVE_TIME'})}>*/}
                    {/*    {StringUtils.formatTime(props.visitRequest?.arriveStartTime) + "~" + StringUtils.formatTime(props.visitRequest?.arriveEndTime)}*/}
                    {/*</DescriptionItem>*/}
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_PURPOSE'})}>
                        {props.visitRequest?.purpose}
                    </DescriptionItem>
                    {props.requestVisitor.remarks!==''?
                        <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_EMPLOYEE_NO'})}>
                        {props.requestVisitor.remarks}
                    </DescriptionItem>:null}
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_NAME'})}>
                        {props.requestVisitor.fullName}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_MOBILE'})}>
                        {props.requestVisitor.mobile}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_EMAIL'})}>
                        {props.requestVisitor.email}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_COMPANY'})}>
                        {props.requestVisitor.company}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ID_NUMBER'})}>
                        {props.requestVisitor.idNumber}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VISIT_CODE'})}>
                        {props.requestVisitor.visitCode}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_STATUS'})}>
                        <FormattedMessage id={VisitorStatus.Map.get(props.requestVisitor.status)}/>
                    </DescriptionItem>
                    {/*<DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_CHECKIN_TIME'})}>*/}
                    {/*    {StringUtils.formatDate(props.requestVisitor.checkInLog?.accessDate) + " " + StringUtils.formatTime(props.requestVisitor.checkInLog?.accessTime)}*/}
                    {/*</DescriptionItem>*/}
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ACCESS_IN_TIME'})}>
                        {StringUtils.formatDate(props.requestVisitor.accessInLog?.accessDate) + " " + StringUtils.formatTime(props.requestVisitor.accessInLog?.accessTime)}
                    </DescriptionItem>
                    {/*<DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_CHECKOUT_TIME'})}>*/}
                    {/*    {StringUtils.formatDate(props.requestVisitor.checkOutLog?.accessDate) + " " + StringUtils.formatTime(props.requestVisitor.checkOutLog?.accessTime)}*/}
                    {/*</DescriptionItem>*/}
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ACCESS_OUT_TIME'})}>
                        {StringUtils.formatDate(props.requestVisitor.accessOutLog?.accessDate) + " " + StringUtils.formatTime(props.requestVisitor.accessOutLog?.accessTime)}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_2ND'})}>
                        {host2nd}&nbsp;&nbsp;<a href={'javascript:void(0)'}
                                                onClick={() => _handleClickModify()}><FormattedMessage
                        id={'COMMON_EDIT'}/></a>
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_PLATE_NUMBER'})}>
                        {props.requestVisitor.plateNumber}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_TRANSPORT_GOODS'})}>
                        {carryGoodsJson && carryGoodsJson.transportGoods}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_PERSONAL_GOODS_DESCRIPTION'})}>
                        {carryGoodsJson && carryGoodsJson.personalGoodsDescription}
                    </DescriptionItem>
                </Descriptions>
            </CardContent>
        </Card>
    );
};

export default VisitorDetailCard;
